/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Collapse, message } from "antd";
import RateMatrixTable from "./RateMatrixTable";
import zone_location_Icon from "../../../assests/images/master/zone-location-icon.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import { capitaliseWithHyphen } from "../../../utils";
const { GET_DEFAULT_RATE_CARD } = urls;
const RateMatrix = ({
  rateMatrixData,
  quotationRateMatrix,
  type,
  actionEdit,
}) => {
  const { Panel } = Collapse;
  const [standardDoxSurface, setStandardDoxSurface] = useState([]);
  const [standardDoxAir, setStandardDoxAir] = useState([]);
  const [standardNonDoxSurface, setStandardNonDoxSurface] = useState([]);
  const [standardNonDoxAir, setStandardNonDoxAir] = useState([]);

  const [fastTrackSurface, setFastTrackSurface] = useState([]);
  const [fastTrackAir, setFastTrackAir] = useState([]);
  const [fastTrackNonDoxSurface, setFastTrackNonDoxSurface] = useState([]);
  const [fastTrackNonDoxAir, setFastTrackNonDoxAir] = useState([]);

  const [valuePlusDoxSurface, setValuePlusDoxSurface] = useState([]);
  const [valuePlusDoxAir, setValuePlusDoxAir] = useState([]);
  const [valuePlusNonDoxSurface, setValuePlusNonDoxSurface] = useState([]);
  const [valuePlusNonDoxAir, setValuePlusNonDoxAir] = useState([]);

  const [extraZones, setExtraZones] = useState([]);

  useEffect(() => {
    getDefaultRate();
  }, [quotationRateMatrix]);

  const defaultRates = [
    "local",
    "withinZone",
    "myZone1",
    "myZone2",
    "myZone3",
    "myZone4",
    "metro",
    "specialLocation",
    "roi",
    "minValue",
    "maxValue",
    "volume",
    "unit",
  ];

  const updatedRates =
    type === "viewCash"
      ? defaultRates.filter(
          (rate) => !["myZone1", "myZone2", "myZone3", "myZone4"].includes(rate)
        )
      : defaultRates;

  useEffect(() => {
    rateMatrixData({
      standardDoxSurface,
      standardDoxAir,
      standardNonDoxSurface,
      standardNonDoxAir,
      fastTrackSurface,
      fastTrackAir,
      fastTrackNonDoxSurface,
      fastTrackNonDoxAir,
      valuePlusDoxSurface,
      valuePlusDoxAir,
      valuePlusNonDoxSurface,
      valuePlusNonDoxAir,
    });
  }, [
    standardDoxSurface,
    standardDoxAir,
    standardNonDoxSurface,
    standardNonDoxAir,
    fastTrackSurface,
    fastTrackAir,
    fastTrackNonDoxSurface,
    fastTrackNonDoxAir,
    valuePlusDoxSurface,
    valuePlusDoxAir,
    valuePlusNonDoxSurface,
    valuePlusNonDoxAir,
  ]);

  const transformArray = (current, past) =>
    current?.map((obj, i) => ({
      title: `Up to ${obj.maxValue || obj.volume} Gms`,
      design: obj.volume,
      minValue: obj.minValue,
      oldPresent: past ? true : false,
      value: [
        {
          title: "LOCAL",
          value: (obj.local || 0).toFixed(2),
          pastVal: past ? (past[i]?.local || 0).toFixed(2) : null,
        },
        {
          title: "WITHIN STATE",
          value: (obj.withinZone || 0).toFixed(2),
          pastVal: past ? (past[i]?.withinZone || 0).toFixed(2) : null,
        },

        ...(type !== "viewCash"
          ? [
              {
                title: "My Zone 1",
                value: (obj.myZone1 || 0).toFixed(2),
                pastVal: past ? (past[i]?.myZone1 || 0).toFixed(2) : null,
              },
              {
                title: "My Zone 2",
                value: (obj.myZone2 || 0).toFixed(2),
                pastVal: past ? (past[i]?.myZone2 || 0).toFixed(2) : null,
              },
              {
                title: "My Zone 3",
                value: (obj.myZone3 || 0).toFixed(2),
                pastVal: past ? (past[i]?.myZone3 || 0).toFixed(2) : null,
              },
              {
                title: "My Zone 4",
                value: (obj.myZone4 || 0).toFixed(2),
                pastVal: past ? (past[i]?.myZone4 || 0).toFixed(2) : null,
              },
            ]
          : []),
        {
          title: "METRO",
          value: (obj.metro || 0).toFixed(2),
          pastVal: past ? (past[i]?.metro || 0).toFixed(2) : null,
        },
        {
          title: "SPECIAL LOCATION",
          value: (obj.specialLocation || 0).toFixed(2),
          pastVal: past ? (past[i]?.specialLocation || 0).toFixed(2) : null,
        },
        {
          title: "REST OF INDIA",
          value: (obj.roi || 0).toFixed(2),
          pastVal: past ? (past[i]?.roi || 0).toFixed(2) : null,
        },
        ...(type === "viewCash"
          ? Object.entries(obj)
              .filter(([key]) => !updatedRates.includes(key))
              .map(([key, value]) => ({
                title: key.toUpperCase(),
                value: (value || 0).toFixed(2),
                pastVal: past
                  ? (past[i]?.[key.toLowerCase()] || 0).toFixed(2)
                  : null,
              }))
          : []),
      ],
    }));

  const getDefaultRate = async () => {
    const data = quotationRateMatrix;
    if (type === "viewCash") {
      setExtraZones(
        Object.entries(data?.dox?.surface?.standard[0])
          .filter(([key]) => !updatedRates.includes(key))
          .map(([key, value]) => ({
            title: capitaliseWithHyphen(key),
            imgSrc: zone_location_Icon,
          }))
      );
    }

    const updateRates = (setter, current, past) => {
      setter(transformArray(current, past));
    };

    updateRates(
      setStandardDoxSurface,
      data?.dox?.surface?.standard,
      data?.dox?.surface?.standard_old || null
    );
    updateRates(
      setStandardDoxAir,
      data?.dox?.air?.standard,
      data?.dox?.air?.standard_old || null
    );
    updateRates(
      setStandardNonDoxSurface,
      data?.nonDox?.surface?.standard,
      data?.nonDox?.surface?.standard_old || null
    );
    updateRates(
      setStandardNonDoxAir,
      data?.nonDox?.air?.standard,
      data?.nonDox?.air?.standard_old || null
    );

    updateRates(
      setFastTrackAir,
      data?.dox?.air?.fastTrack,
      data?.dox?.air?.fastTrack_old || null
    );
    updateRates(
      setFastTrackSurface,
      data?.dox?.surface?.fastTrack,
      data?.dox?.surface?.fastTrack_old || null
    );
    updateRates(
      setFastTrackNonDoxSurface,
      data?.nonDox?.surface?.fastTrack,
      data?.nonDox?.surface?.fastTrack_old || null
    );
    updateRates(
      setFastTrackNonDoxAir,
      data?.nonDox?.air?.fastTrack,
      data?.nonDox?.air?.fastTrack_old || null
    );

    updateRates(
      setValuePlusDoxSurface,
      data?.dox?.surface?.valuePlus,
      data?.dox?.surface?.valuePlus_old || null
    );
    updateRates(
      setValuePlusDoxAir,
      data?.dox?.air?.valuePlus,
      data?.dox?.air?.valuePlus_old || null
    );

    updateRates(
      setValuePlusNonDoxSurface,
      data?.nonDox?.surface?.valuePlus,
      data?.nonDox?.surface?.valuePlus_old || null
    );
    updateRates(
      setValuePlusNonDoxAir,
      data?.nonDox?.air?.valuePlus,
      data?.nonDox?.air?.valuePlus_old || null
    );
  };

  const setWeightSlabData = (data, title) => {
    switch (title) {
      case "standardDocsSurface":
        setStandardDoxSurface(data);
        break;
      case "standardDocsAir":
        setStandardDoxAir(data);
        break;
      case "standardNonDocsSurface":
        setStandardNonDoxSurface(data);
        break;
      case "standardNonDocsAir":
        setStandardNonDoxAir(data);
        break;

      case "fastTrackSurface":
        setFastTrackSurface(data);
        break;
      case "fastTrackAir":
        setFastTrackAir(data);
        break;
      case "fastTrackNonDoxSurface":
        setFastTrackNonDoxSurface(data);
        break;
      case "fastTrackNonDoxAir":
        setFastTrackNonDoxAir(data);
        break;
      case "valueplusDoxSurface":
        setValuePlusDoxSurface(data);
        break;
      case "valueplusDoxAir":
        setValuePlusDoxAir(data);
        break;
      case "valueplusNonDoxSurface":
        setValuePlusNonDoxSurface(data);
        break;
      case "valueplusNonDoxAir":
        setValuePlusNonDoxAir(data);
        break;
    }
  };

  const changeDynamicSelect = (title, data) => {
    switch (title) {
      case "standardNonDocsSurface":
        setStandardNonDoxSurface(data);
        break;
      case "standardNonDocsAir":
        setStandardNonDoxAir(data);
        break;
      case "fastTrackNonDoxSurface":
        setFastTrackNonDoxSurface(data);
        break;
      case "fastTrackNonDoxAir":
        setFastTrackNonDoxAir(data);
        break;
      case "valueplusNonDoxSurface":
        setValuePlusNonDoxSurface(data);
        break;
      case "valueplusNonDoxAir":
        setValuePlusNonDoxAir(data);
        break;
    }
  };
  return (
    <div>
      <Collapse collapsible={"header"} defaultActiveKey={["2"]}>
        <Panel header="Rate Matrix" key="2">
          <RateMatrixTable
            standardDocsSurfaceData={standardDoxSurface}
            standardDocsAirData={standardDoxAir}
            standardNonDocsSurfaceData={standardNonDoxSurface}
            standardNonDocsAirData={standardNonDoxAir}
            fastTrackSurfaceData={fastTrackSurface}
            fastTrackAirData={fastTrackAir}
            fastTrackNonDoxSurfaceData={fastTrackNonDoxSurface}
            fastTrackNonDoxAirData={fastTrackNonDoxAir}
            valuePlusDoxSurfaceData={valuePlusDoxSurface}
            valuePlusDoxAirData={valuePlusDoxAir}
            valuePlusNonDoxAirData={valuePlusNonDoxAir}
            valuePlusNonDoxSurfaceData={valuePlusNonDoxSurface}
            handleChangeDocs={(e, data) => setWeightSlabData(e, data)}
            handleDynamicSelect={(data, title) =>
              changeDynamicSelect(data, title)
            }
            templateType={actionEdit ? "create" : "view"}
            extraZone={extraZones}
            type={type}
          />
        </Panel>
      </Collapse>
    </div>
  );
};
export default RateMatrix;
